import { useEffect, useState } from "react";
import { api, inr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Wallet, Landmark, Smartphone, ArrowUpRight, ArrowDownRight } from "lucide-react";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow
} from "@/components/ui/table";

export default function CashBank() {
  const [payments, setPayments] = useState([]);
  useEffect(() => {
    api.get("/payments").then((r) => setPayments(r.data));
  }, []);
  const byMethod = payments.reduce((acc, p) => {
    const k = (p.method || "Cash").toLowerCase();
    if (k.includes("cash")) acc.cash += p.amount || 0;
    else if (k.includes("upi")) acc.upi += p.amount || 0;
    else acc.bank += p.amount || 0;
    return acc;
  }, { cash: 0, bank: 0, upi: 0 });

  return (
    <div className="space-y-6" data-testid="cash-bank-page">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Cash &amp; Bank</h1>
        <p className="text-sm text-muted-foreground mt-1">Cash on hand, bank and UPI balances</p>
      </div>
      <div className="grid sm:grid-cols-4 gap-4">
        <StatCard icon={Wallet} label="Cash in Hand" value={inr(byMethod.cash)} color="text-emerald-600" />
        <StatCard icon={Landmark} label="Bank" value={inr(byMethod.bank)} color="text-blue-600" />
        <StatCard icon={Smartphone} label="UPI" value={inr(byMethod.upi)} color="text-violet-600" />
        <StatCard icon={ArrowUpRight} label="Total" value={inr(byMethod.cash + byMethod.bank + byMethod.upi)} color="text-primary" highlight />
      </div>
      <Card className="overflow-hidden">
        <div className="p-4 border-b font-heading font-bold">Recent Cash Flow</div>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Party</TableHead>
              <TableHead>Method</TableHead>
              <TableHead>Reference</TableHead>
              <TableHead className="text-right">Amount</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {payments.map((p) => (
              <TableRow key={p.id}>
                <TableCell>{(p.payment_date || p.created_at || "").slice(0, 10)}</TableCell>
                <TableCell className="font-medium">{p.customer_name || "—"}</TableCell>
                <TableCell>{p.method}</TableCell>
                <TableCell>{p.reference || "—"}</TableCell>
                <TableCell className="text-right font-semibold text-emerald-600">+{inr(p.amount)}</TableCell>
              </TableRow>
            ))}
            {payments.length === 0 && (
              <TableRow><TableCell colSpan={5} className="text-center text-sm text-muted-foreground py-8">No transactions yet.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}

function StatCard({ icon: Icon, label, value, color, highlight }) {
  return (
    <Card className={`p-5 ${highlight ? "border-primary/40 bg-primary/5" : ""}`}>
      <div className={`w-9 h-9 rounded-lg bg-muted grid place-items-center mb-2 ${color}`}><Icon size={16} /></div>
      <div className="text-xs uppercase tracking-widest text-muted-foreground">{label}</div>
      <div className="font-heading font-bold text-2xl mt-1">{value}</div>
    </Card>
  );
}
